import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const carbonInventoryService = createApi({
    reducerPath: 'carbonInventoryService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['CarbonInventory'],
    endpoints: (builder) => ({
        getAllCarbonInventory: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonInventoryController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveCarbonInventory: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonInventoryController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateCarbonInventory: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonInventoryController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteCarbonInventory: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonInventoryController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getCarbonInventoryById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonInventoryController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadCarbonInventory: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonInventoryController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        findAllCarbonInventory: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonInventoryController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
    })
});

export const {
    useGetAllCarbonInventoryMutation,
    useSaveCarbonInventoryMutation,
    useUpdateCarbonInventoryMutation,
    useDeleteCarbonInventoryMutation,
    useGetCarbonInventoryByIdMutation,
    useBulkUploadCarbonInventoryMutation,
    useFindAllCarbonInventoryMutation,
} = carbonInventoryService;
